import React from "react";
import "./CorporateCreate.css"
import leftArrow from "../../../../assests/leftArrow.svg";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import CreateCorporateComponentOnBoarding from "./CreateCorporate/component";
import UsageLimitComponent from "./UsageLimit/component";
import AddDepartmentComponent from "./CreateDepartment/component";

const CorporateCreateComponent = (props) => {
  const steps = [
    "Create Corporate",
    "Setup Department",
    "Usage Limit",
  ];

  const navigate = useNavigate();
  
  const handleClick = () => {
    navigate(-1);
  };

  return (
    <div className="corporate-create-layout">
      <Sidebar />

      <div className="corporate-create-content">
        <div className="corporate-create-header">
          <button onClick={handleClick} className="corporate-back-button">
            <img src={leftArrow} alt="Back" />
          </button>
          <h2 className="corporate-create-title">Create a Corporate</h2>
        </div>

        <div className="corporate-stepper-wrapper">
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={props.activeStep}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>
        
        <div className="corporate-form-wrapper">
          <div className="corporate-step-content">
            {props.activeStep === 0 && (
              <CreateCorporateComponentOnBoarding
                createCorporateData={props.createCorporateData}
                handleChangeCorporate={props.handleChangeCorporate}
                setCreateCorporateData={props.setCreateCorporateData}
                loading={props.loading}
              />
            )}
            {props.activeStep === 1 && (
              <AddDepartmentComponent
                departments={props.departments}
                handleAddDepartment={props.handleAddDepartment}
                handleRemoveDepartment={props.handleRemoveDepartment}
                handleDepartmentChange={props.handleDepartmentChange}
                handleBalanceChange={props.handleBalanceChange}
                useDefaultDepartment={props.useDefaultDepartment}
                handleUseDefaultChange={props.handleUseDefaultChange}
                defaultBalance={props.defaultBalance}
                handleDefaultBalanceChange={props.handleDefaultBalanceChange}
                availableDepartments={props.availableDepartments}
                fetchingDepartments={props.fetchingDepartments}
                loading={props.loading}
              />
            )}
            {props.activeStep === 2 && (
              <UsageLimitComponent
                usageLimitRequired={props.usageLimitRequired}
                handleUsageLimitChange={props.handleUsageLimitChange}
                onLimitsChange={props.onLimitsChange}
                initialLimits={props.initialLimits}
                loading={props.loading}
              />
            )}
          </div>

          <div className="corporate-action-buttons">
            <Button
              className="corporate-action-cancel"
              onClick={props.handleClose}
              disabled={props.activeStep === 0 || props.loading}
            >
             Previous
            </Button>
            <Button
              className="corporate-action-save"
              variant="contained"
              onClick={props.handleNext}
              disabled={props.loading}
            >
              {props.loading ? "Processing..." : props.activeStep === steps.length - 1 ? "Save" : "Save and Continue"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorporateCreateComponent;